import React from "react";
import CustomDropdown from "./CustomDropdown/CustomDropdown";
import CustomDatepicker from "./CustomDatepicker/CustomDatepicker";
import commonConfig from "../../commonConfig.json";

let dropDownConfigs = commonConfig.dropdownProps;
let datePickerConfigs = commonConfig.datePickerProps;

export const CreateDropDown = (index) => {
    let dropdownProps = {
        key: 'comp_search_' + index.name,
        dropdownType: index.mode !== undefined ? (index.mode === dropDownConfigs.mode.SINGLE ? dropDownConfigs.dropdownType.SELECT : dropDownConfigs.dropdownType.TREESELECT) : dropDownConfigs.dropdownType.SELECT,
        mode: index.mode !== undefined ? index.mode : dropDownConfigs.mode.SINGLE,
        disabled: (index.values.length < 2 ? true : false),
        labelName: index.name,
        labelPosition: dropDownConfigs.labelPosition.VERTICAL,
        placeholder: 'Please select ' + index.name,
        options: index.values,
        selectedOptions: index.selectedValue,
        showSearch: index.mode !== undefined ? (index.mode === dropDownConfigs.mode.SINGLE ? false : true) : false,
        grouping: index.grouped !== undefined ? index.grouped : false,
        groupingMode: index.groupingMode !== undefined ? index.groupingMode : [],
        apply: index.mode !== undefined ? (index.mode === dropDownConfigs.mode.SINGLE ? dropDownConfigs.apply.ONCHANGE : dropDownConfigs.apply.ONAPPLY) : dropDownConfigs.apply.ONCHANGE,
        callback: index.onChangeFn,
        groupingUpdateCallback: index.onGroupingUpdateFn !== undefined ? index.onGroupingUpdateFn : null,
        indexName: index.name,
        indexValType: index.valuesType,
        indexType: index.type,
        indexCategory: index.indexCategory, //HMG,Solution,dependent,depending,independent
        indexOrder: index.order,

    }
    return (<CustomDropdown {...dropdownProps} />);
}



export const CreateDatePicker = (index) => {
    let datepickerProps = {
        key: 'comp_search_' + index.name,
        mode: index.mode !== undefined ? index.mode : datePickerConfigs.mode.SINGLE,
        modeExtensions: index.modeExtensions !== undefined ? index.modeExtensions : [],
        pickerType: index.pickerType !== undefined ? index.pickerType : datePickerConfigs.pickerType.DATE,
        disabled: false,
        format: index.format !== undefined ? index.format : "MM-DD-YYYY",
        selectedRange: index.selectedRange !== undefined ? index.selectedRange : [],
        disabledRange: index.disallowRange !== undefined ? index.disallowRange : {},
        apply: index.apply !== undefined ? index.apply : datePickerConfigs.apply.ONCHANGE,
        callback: index.onChangeFn,
        indexName: index.name,
        indexValType: index.valuesType,
        indexType: index.type,
        indexCategory: index.indexCategory, //HMG,Solution,dependent,depending,independent
        indexOrder: index.order,
        labelName: index.name === "Date" ? "Business Date" : index.name,
        labelPosition: datePickerConfigs.labelPosition.VERTICAL,
        placeholder: index.format !== undefined ? (index.mode === datePickerConfigs.mode.RANGE ? [index.format, index.format] : index.format) : (index.mode === datePickerConfigs.mode.RANGE ? ["MM-DD-YYYY", "MM-DD-YYYY"] : "MM-DD-YYYY")
    }

    return (<CustomDatepicker {...datepickerProps} />);
}
